import { render, staticRenderFns } from "./AuthorFollowItem.vue?vue&type=template&id=1015e6b6&scoped=true&"
import script from "./AuthorFollowItem.vue?vue&type=script&lang=js&"
export * from "./AuthorFollowItem.vue?vue&type=script&lang=js&"
import style0 from "./AuthorFollowItem.vue?vue&type=style&index=0&id=1015e6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1015e6b6",
  null
  
)

export default component.exports